import React, {  useEffect, useState, } from "react";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import dateFormat from "dateformat";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import AkkhorLayout from "../../layout/AkkhorLayout";

export default function MyProfile() {
    const { user } = useSelector((state) => state.auth);
    const [detail, setDetail] = useState(user);

    useEffect(() => {
        Axios.get("https://apihr.bhsgroup.vn/api/user_info/" + user.data.id + "?select_info=1", user.config)
            .then(async (res) => {
                if (res.data.status === "success") {
                    setDetail(res.data.data)
                } else console.log(res.data.message);
            })
            .catch((err) => console.log(err));
    }, [user]);// eslint-disable-line

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>Thông tin cá nhân</li>
                </ul>
            </div>

            {detail && <div className="card height-auto mt-2">
                <div className="card-body">
                    <div className="single-info-details">
                        <div className="item-content">
                            <div className="header-inline item-header">
                                <h3 className="text-dark-medium font-medium">{detail.fullname}</h3>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 mb-5"></div>
                                <div className="col-lg-12 info-table table-responsive">
                                    <h5>Thông tin cá nhân:</h5>
                                    <div className="row">
                                        <div className="col-5 col-sm-3">Họ và tên:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.fullname}</div>
                                        <div className="col-5 col-sm-3">Mã số nhân viên:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.code}</div>
                                        {detail.company &&
                                            <>
                                                <div className="col-5 col-sm-3">Công ty:</div>
                                                <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.company}</div>
                                            </>
                                        }
                                        {detail.part &&
                                            <>
                                                <div className="col-5 col-sm-3">Phòng ban:</div>
                                                <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.part}</div>
                                            </>
                                        }
                                        {detail.chucvu &&
                                            <>
                                                <div className="col-5 col-sm-3">Chức vụ:</div>
                                                <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.chucvu}</div>
                                            </>
                                        }

                                        <div className="col-5 col-sm-3">Email:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.email}</div>

                                        <div className="col-5 col-sm-3">Số điện thoại:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.mobile}</div>


                                        <div className="col-5 col-sm-3">Ngày gia nhập:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{dateFormat(detail.datejoining, 'dd-mm-yyyy')}</div>

                                        <div className="col-5 col-sm-3">Giới tính:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.sex}</div>

                                        <div className="col-5 col-sm-3">Ngày sinh:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{dateFormat(detail.birthday, 'dd-mm-yyyy')}</div>

                                        <div className="col-5 col-sm-3">Địa chỉ liên lạc:</div>
                                        <div className="col-7 col-sm-9 font-medium text-dark-medium">{detail.address}</div>

                                    </div>
                                </div>
                                
                            </div>
                            <div><hr /></div>
                        </div>
                    </div>
                </div>
            </div>}
        </AkkhorLayout>
    );
}
